import { render, staticRenderFns } from "./JobRemarksEdit.vue?vue&type=template&id=4fddecf2&"
import script from "./JobRemarksEdit.vue?vue&type=script&lang=js&"
export * from "./JobRemarksEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports